<template>
    <div class="container-fluid">
        <Breadcrumb button-url="unsubscriberCreate" title="Unsubscribers"></Breadcrumb>
        <div class="row el-element-overlay" style="position: relative">
            <div class="col-12 row-preloader" v-if="loading">
                <Preloader v-bind:class="{preloader: loading}"></Preloader>
            </div>
            <div class="col-12" v-else>
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group p-t-10">
                                <div class="progress" v-for="(uploadFile,index) in uploadData" :key="index">
                                    <div class="progress-bar bg-info"
                                         v-bind:style="{width: uploadFile.completion}" role="progressbar"
                                         aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">
                                        {{uploadFile.completion}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <treeselect placeholder="Search by category"
                                            v-model="categorySearch"
                                            :multiple="false"
                                            :options="categoryList"
                                            :load-options="loadCategoryList"
                                />
                            </div>
                            <input v-model="emailSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search by Email">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                        </div>
                        <div class="card-body">
                            <div v-if="unsubscribers.length > 0">
                                <div class="table-responsive">
                                    <table class="table" id="unsubscriberTable">
                                        <thead>
                                        <tr>
                                            <th>Email</th>
                                            <th>Category</th>
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr :key="index" v-for="(unsubscriber, index) in unsubscribers">
                                            <td>{{unsubscriber.email.email}}</td>
                                            <td>{{unsubscriber.category.name}}</td>
                                            <td>
                                                <button @click="deleteUnsubscriber(unsubscriber.id)"
                                                        class="btn btn-danger"
                                                        type="button">
                                                    <i class="fa fa-minus-circle"></i> Delete
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <paginate :click-handler="getItems"
                                          :container-class="'pagination justify-content-center'"
                                          :margin-pages="2"
                                          :next-class="'page-item'"
                                          :next-link-class="'page-link'"
                                          :next-text="'Next'"
                                          :page-class="'page-item'"
                                          :page-count="pageCount"
                                          :page-link-class="'page-link'"
                                          :page-range="3"
                                          :prev-class="'page-item'"
                                          :prev-link-class="'page-link'"
                                          :prev-text="'Prev'"
                                          v-if="pageCount > 1"
                                          v-model="page">
                                </paginate>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import UnsubscriberService from '../services/UnsubscriberService'
    import Preloader from '../components/Preloader';
    import CategoryService from '../services/CategoryService'
    import Treeselect from '@riophae/vue-treeselect'
    import Breadcrumb from '../components/Breadcrumb';
    import config from '../config';
    import paginateMixin from '../mixins/paginate-mixin';
    import {mapGetters} from 'vuex';

    export default {
        name: 'Unsubscribers',
        components: {
            Preloader,
            Treeselect,
            Breadcrumb
        },
        mixins: [paginateMixin],
        data() {
            return {
                categoryList: null,
                categorySearch: null,
                emailSearch: null,
                unsubscribers: [],
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
                loading: false,
                uploadData: []
            }
        },
        mounted() {
            this.getItems(this.page = 1);
            this.uploadProgress();
        },
        methods: {
            loadCategoryList({callback}) {
                CategoryService.getCategorySelect().then(response => {
                    this.categoryList = response.data['hydra:member'].map(category => {
                        return {id: category.id, label: category.name}
                    });
                    callback();
                });
            },
            deleteUnsubscriber(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return UnsubscriberService.deleteUnsubscriber(id).then(() => {
                            let unsubscriberIndex = this.unsubscribers.findIndex(obj => obj.id === id);
                            this.unsubscribers.splice(unsubscriberIndex, 1);
                        }).catch(error => {
                            Swal.showValidationMessage(
                                `Request failed: ${error}`
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Unsubscriber has been deleted.`,
                            'success'
                        )
                    }
                })
            },
            search: function () {
                this.getItems(this.page = 1);
            },
            getItems: function (pageNum) {
                this.loading = true;
                UnsubscriberService.getUnsubscribers(
                    pageNum,
                    this.perPage,
                    this.categorySearch,
                    this.emailSearch
                ).then(response => {
                    this.unsubscribers = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                });
            },
            uploadProgress: function () {
                if (!this.mercureListen.hasOwnProperty(config.uploadUnsubscriberProgressStatus)) {
                    let url = new URL(config.mercureHubUrl);
                    url.searchParams.append('topic', config.uploadUnsubscriberProgressStatus);
                    let eventSource = new EventSource(url.toString());
                    this.$store.commit('setListening', {[config.uploadUnsubscriberProgressStatus]: eventSource});
                }
                this.mercureListen[config.uploadUnsubscriberProgressStatus].onmessage = event => {
                    let data = JSON.parse(event.data);
                    if (data) {
                        let index = this.uploadData.findIndex(obj => obj.uuid === data.uuid);
                        if (index < 0) {
                            this.uploadData.push({
                                'uuid': data.uuid,
                                'completion': parseInt(data.completion) + '%'
                            });
                        } else {
                            this.uploadData[index].completion = parseInt(data.completion) + '%';
                            if (100 === parseInt(data.completion)) {
                                this.$snotify.success('File ' + data.filename + ' is processed!');
                                this.uploadData.splice(index, 1);
                                this.getItems(this.page);
                            }
                        }
                    }
                }
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            },
            ...mapGetters({mercureListen: 'listen'})
        }
    }
</script>

<style scoped>

</style>